import React from "react";
import { Step, StepLabel, Stepper } from "@mui/material";
import cls from "./MflistExcelinput.module.css";

const PROD_STEPS = ["업로드", "검증", "보정", "저장"];
const TRAIN_STEPS = ["설정", "생성", "검증", "미리보기"];

export default function BulkInputStepper({ mode, activeStep }) {
  const steps = mode === "training" ? TRAIN_STEPS : PROD_STEPS;
  return (
    <div className={cls.stepperWrap}>
      <Stepper activeStep={activeStep} alternativeLabel sx={{ py: 0.5 }}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  );
}
